<template>
  <LPolygon
    v-if="coordinates.length"
    :lat-lngs="coordinates"
    :color="color"
    :fill-color="color"
    bubblingMouseEvents
    @click="handleClick"
    @ready="handleReady"
  >
    <LTooltip v-if="name" :content="name" :options="tooltipOptions" ref="tooltipEl" @ready="handleTooltipReady" />
  </LPolygon>
</template>

<script>
import { LPolygon, LTooltip } from 'vue2-leaflet'
import { mapState } from 'vuex'

export default {
  name: 'MapPolygon',
  components: {
    LPolygon,
    LTooltip
  },
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: null
    },
    coordinates: {
      type: Array,
      default: () => []
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      polygon: null
    }
  },
  computed: {
    ...mapState('map', ['map']),
    tooltipOptions() {
      return {
        className: 'fpm-area-tooltip',
        permanent: true,
        direction: 'center'
      }
    }
  },
  methods: {
    handleClick() {
      this.$emit('click', this.id)
    },
    handleReady(polygon) {
      this.polygon = polygon
      this.editable && this.editOn()
    },
    handleEdit(e) {
      // swap x and y because it's already changed somewhere
      const coordinates = e.target.toGeoJSON()?.geometry?.coordinates[0]?.map(([x, y]) => [y, x])
      if (coordinates) {
        this.$emit('change', { id: this.id, coordinates })
      }
    },
    editOn() {
      this.polygon?.pm.enable({
        allowSelfIntersection: false
      })
      this.polygon?.on('pm:edit', (e) => {
        this.handleEdit(e)
      })
    },
    editOff() {
      this.polygon?.pm.disable()
    },
    handleTooltipReady() {
      this.refreshTooltip()
    },
    async refreshTooltip() {
      await this.$nextTick()
      this.$refs.tooltipEl?.parentContainer?.mapObject.bindTooltip(this.name, this.tooltipOptions)
    }
  },
  mounted() {
    this.editable && this.editOn()
    this.refreshTooltip()
  },
  watch: {
    name() {
      this.refreshTooltip()
    },
    editable(v) {
      v ? this.editOn() : this.editOff()
    }
  }
}
</script>

<style lang="scss">
.fpm-area-tooltip {
  color: blue !important;
  text-align: center;
  font-size: 12px;
  line-height: 10px !important;
  margin-top: 0 !important;

  box-shadow: none !important;
  padding: 0 !important;
  background-color: transparent !important;
  border: none !important;
  text-shadow: 1px 1px 0 #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 0 0 #fff;

  &:before {
    display: none;
  }
}
</style>
